import { AuthenticationStrengthPolicy } from '@microsoft/microsoft-graph-types-beta';
import { createAction, props } from '@ngrx/store';

export const loadAuthenticationStrengthPolicies = createAction(
    '[Graph/Authentication Strength] Load Authentication Strength Policies ',
    props<{ _tenant: string }>(),
);

export const loadAuthenticationStrengthPoliciesSuccess = createAction(
    '[Graph/Authentication Strength] Load Authentication Strength Policies Success',
    props<{ _tenant: string; polices: AuthenticationStrengthPolicy[] }>(),
);

export const loadAuthenticationStrengthPoliciesFailure = createAction(
    '[Graph/Authentication Strength] Load Authentication Strength Policies Failure',
    props<{ _tenant: string; error: any }>(),
);
